import query from '../util/query'
import omegaStats from './omegastats'

export default {
  setOmega (param) {
    window.Omega.setConfig(param)
  },
  /**
   * 新增在 attrs 中传递 url 中的 query
   *
   * @param {*} id
   * @param {*} label
   * @param {*} attrs
   */
  trackEvent (id, label, attrs) {
    // 获取passQuery
    let params = query.getPassQuery()
    window.Omega.trackEvent(id, label, {
      channel: params.channel || params.channel_id,
      dchn: params.dchn,
      ...attrs
    })
  },
  Omega: window.Omega,
  omegaStats
}
